import NextLink from 'next/link'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useSETrackEvent } from 'app/DocumentCollectionPage/hooks/useSETrackEvent'

import type { TDocumentCategory } from 'types/document-collection'

interface ICategoryListItemProps extends TDocumentCategory {
  onNextPage?: () => void
}

const CategoryListItem: React.FC<ICategoryListItemProps> = ({
  id,
  name,
  description,
  categoryType,
  thumbnailUrl,
  onNextPage,
}) => {
  const { SETrackDocumentLandingPage } = useSETrackEvent()

  const url =
    categoryType === 'CT_END_CATEGORY'
      ? `/dokumen/daftar/${id}`
      : `/dokumen/kategori/${id}`

  return (
    <li>
      <NextLink href={url} passHref>
        <a
          className="flex items-center justify-between p-4 space-x-4 bg-white rounded-md shadow-card"
          onClick={() => {
            onNextPage?.()
            SETrackDocumentLandingPage('CLICK_KUMPULAN_DOKUMEN_CATEGORY', {
              screen_name: 'KUMPULAN_DOKUMEN_LANDING_PAGE',
              event_trigger: 'KUMPULAN_DOKUMEN_LANDING_PAGE',
              page_element: name,
              url: `${window.location.origin}${url}`,
            })
          }}
        >
          {Boolean(thumbnailUrl) && (
            <img
              src={thumbnailUrl}
              alt={`${name} thumbnail`}
              width="40px"
              height="40px"
              className="flex-none object-cover object-center w-10 h-10 grow-0"
            />
          )}

          <div className="flex grow">
            <div className="grow">
              <div className="line-clamp-2">
                <Text variant="action">{name}</Text>
              </div>
              <div className="line-clamp-2">
                <Text variant="body-sm" color="subdued">
                  {description}
                </Text>
              </div>
            </div>
            <div className="flex-none grow-0">
              <Icon>chevron_right</Icon>
            </div>
          </div>
        </a>
      </NextLink>
    </li>
  )
}

export default CategoryListItem
